/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// React Router DOM
import { useHistory, useLocation, Redirect } from 'react-router-dom';

// Material UI
import { ListItem, ListItemText, Typography } from '@material-ui/core';

// Actions
import * as CollapseActions from 'store/ducks/collapse/actions';
import * as RoutesActions from 'store/ducks/routes/actions';
import * as CurrentModuleActions from 'store/ducks/currentModule/actions';

// Types
import { ApplicationState } from 'store';

// Helpers
import { getToken, isAuthorized } from 'helpers/auth';
import { getItemOpen, removeItemOpen, setCurrentPath } from 'helpers/drawer';

// Constants
import PATH from 'constants/basePath';

// Styles
import useStyles from '../../styles';

interface StateProps {
  modules: string[];
  types: string[];
  title: string;
  subtitle?: string;
  pathRoute?: string;
  externalPathRoute?: string;
  className?: any;
  titleStyle?: any;
  icon?: React.ReactNode;
  setIsCollapse?: any;
  isCollapse?: any;
  isOpen?: boolean;
  currentTitle?: string;
  isConsortion: boolean;
  moduleConsortionHasAutorization?: boolean;
  moduleConsortionHasAllAutorization?: boolean;
  // Icon?: keyof typeof Icons
}

type Props = StateProps;

const MenuItem: React.FunctionComponent<Props> = ({
  modules,
  types,
  title,
  icon,
  subtitle,
  pathRoute,
  externalPathRoute,
  className,
  titleStyle,
  setIsCollapse,
  isCollapse,
  isOpen,
  currentTitle = '',
  isConsortion,
  moduleConsortionHasAutorization,
  moduleConsortionHasAllAutorization,
}) => {
  const classes = useStyles();

  const history = useHistory();
  const { pathname: routeActive } = useLocation();
  const dispatch = useDispatch();

  const collapseList = useSelector(
    (state: ApplicationState) => state.collapse.collapseList,
  );

  const currentModuleDate = useSelector(
    (state: ApplicationState) => state.currentModule.currentModuleData,
  );

  if (!getToken()) {
    return <Redirect to={PATH.LOGIN} />;
  }

  if (
    !isAuthorized(
      modules,
      types,
      true,
      isConsortion,
      moduleConsortionHasAllAutorization || !!moduleConsortionHasAutorization,
    )
  ) {
    return <></>;
  }

  if (routeActive === pathRoute && currentModuleDate !== modules[0]) {
    dispatch(CurrentModuleActions.setCurrentModule({ module: modules[0] }));
  }

  const handleClick = () => {
    if (title) {
      const closeAllCollapseList = collapseList.map((collapse) => ({
        ...collapse,
        open: false,
      }));

      dispatch(
        CollapseActions.setToggleCollapse({
          collapseList: closeAllCollapseList,
        }),
      );

      const collapseItemOpen = getItemOpen();

      if (collapseItemOpen) removeItemOpen();
    }
    if (subtitle && !pathRoute) {
      const aux: any = {};
      aux.isOpen = !isCollapse?.isOpen;
      if (subtitle !== isCollapse.title && isCollapse?.isOpen) {
        aux.isOpen = isCollapse?.isOpen;
      }
      aux.title = subtitle;
      if (setIsCollapse) {
        setIsCollapse((s: any) => Object.assign({}, s, aux));
      }
    }

    dispatch(
      RoutesActions.setRouteActive({
        routeActive: pathRoute!,
      }),
    );

    setCurrentPath(pathRoute!);
  };

  return (
    <ListItem
      onClick={() =>
        dispatch(CurrentModuleActions.setCurrentModule({ module: modules[0] }))
      }
      button
      className={className}
      selected={routeActive === pathRoute}>
      <ListItemText
        onAuxClick={(e) => {
          handleClick();
          window.open(externalPathRoute || pathRoute, '_blank');
        }}
        onClick={(e) => {
          if (externalPathRoute) {
            window.open(externalPathRoute, '_blank');
          }
          handleClick();

          return pathRoute ? history.push(pathRoute) : null;
        }}
        primary={
          <div className={classes.primaryScope}>
            {icon || ''}
            <Typography className={classes.primaryItem}>
              {title || ''}
            </Typography>
          </div>
        }
        secondary={
          <Typography className={classes.secondaryItem} style={titleStyle}>
            {subtitle || ''}
          </Typography>
        }
      />
    </ListItem>
  );
};

export default MenuItem;
export { MenuItem };
